<ng-container *ngIf="pageType == 'register'">
  <app-register></app-register>
</ng-container>

<ng-container *ngIf="pageType == 'phone-verification'">
  <app-phone-verification></app-phone-verification>
</ng-container>

<ng-container *ngIf="pageType == 'register-parent'">
  <app-register-parent></app-register-parent>
</ng-container>

<ng-container *ngIf="pageType == 'leaderboard-embed'">
  <app-leaderboard-embed></app-leaderboard-embed>
</ng-container>